import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export default function NotFound() {
  const { t, lang } = useLang();
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-alabaster" data-testid="not-found-page">
      <div className="text-center px-6">
        <p className="font-serif text-9xl text-terracotta leading-none">404</p>
        <p className="mt-6 text-navy/70 text-lg">{lang === "fr" ? "Cette page a été traduite… en néant." : "This page has been… lost in translation."}</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 text-terracotta link-underline text-sm tracking-[0.2em] uppercase">
          {t("common.back")}
        </Link>
      </div>
    </div>
  );
}
